import { createSelector } from 'reselect';

import { depotsDropdownMapper, depotsPinMapper } from '../../models/depot';

export const getLoginUser = (state) => state.user;

export const getCurrentUser = (state) => state.routePlannerUser;

export const getUserUid = createSelector(getCurrentUser, ({ uid }) => uid);

export const getUserError = createSelector(
  getCurrentUser,
  (user) => user.error
);

export const getUserLoading = createSelector(
  getCurrentUser,
  (user) => user.loading
);

export const getUserMetadata = createSelector(
  getCurrentUser,
  ({ metadata = {} }) => metadata
);

export const getUserDepots = createSelector(
  getUserMetadata,
  ({ depotAccess = [] }) => depotAccess
);

export const getDepotsMapObject = createSelector(
  getUserDepots,
  depotsPinMapper
);

export const getDepotsForDropDown = createSelector(
  getUserDepots,
  depotsDropdownMapper
);

export const hasDisasterRecoveryAccess = createSelector(
  getUserMetadata,
  (userMetadata) => userMetadata?.accessDisasterRecovery
);
